const cardDefaultFormat = /(\d{1,4})/g;

const cardsMap = [
  {
    type: 'amex',
    pattern: /^3[47]/,
    format: /(\d{1,4})(\d{1,6})?(\d{1,5})?/,
    length: [15],
    cvcLength: [4],
    luhn: true,
    mask: '9999 999999 99999',
  },
  {
    type: 'master',
    pattern:
      /^(5[1-5]|677189)|^(222[1-9]|2[3-6]\d{2}|27[0-1]\d|2720)|^2[2-7]\d{14}$/,
    format: cardDefaultFormat,
    length: [16],
    cvcLength: [3],
    luhn: true,
    mask: '9999 9999 9999 9999',
  },
  {
    type: 'visa',
    pattern: /^4/,
    format: cardDefaultFormat,
    length: [13, 16, 19],
    cvcLength: [3],
    luhn: true,
    mask: '9999 9999 9999 9999',
  },
];

export const cardFromNumber = (num: string) => {
  num = num.replace(/\D/g, '');

  for (const card of cardsMap) {
    if (card.pattern.test(num)) {
      return card;
    }
  }

  return {
    type: 'default',
    mask: '9999 9999 9999 9999',
  };
};

export const DEFAULT_CARD_MASK = '9999 9999 9999 9999';

export const applyMask = (value: string, mask: string) => {
  let maskedValue = '';
  let valueIndex = 0;

  for (let i = 0; i < mask.length; i++) {
    if (mask[i] === '9') {
      if (valueIndex < value.length) {
        maskedValue += value[valueIndex];
        valueIndex++;
      } else {
        break;
      }
    } else {
      if (valueIndex < value.length) {
        maskedValue += mask[i];
      }
    }
  }

  return maskedValue;
};

/**
 * Validates a credit card number using the Luhn algorithm
 * @param cardNumber - The credit card number (can include spaces/dashes)
 * @returns true if the card number passes Luhn validation, false otherwise
 */
export const luhnCheck = (cardNumber: string): boolean => {
  // Remove all non-digit characters
  const digits = cardNumber.replace(/\D/g, '');

  // Luhn algorithm requires at least 2 digits
  if (digits.length < 2) {
    return false;
  }

  let sum = 0;
  let isEven = false;

  // Process digits from right to left
  for (let i = digits.length - 1; i >= 0; i--) {
    let digit = Number.parseInt(digits[i], 10);

    if (isEven) {
      digit *= 2;
      if (digit > 9) {
        digit -= 9;
      }
    }

    sum += digit;
    isEven = !isEven;
  }

  // Card number is valid if sum is divisible by 10
  return sum % 10 === 0;
};